import { Grid } from "@mui/material";
import React from "react";
import CreateCard from "./CreateCard";

function Create() {
  return (
    <div className="Main_div">
      <Grid container justifyContent="center">
        <Grid item xs={11} sm={8} md={11.5} lg={10}>
          <h1 className="heading_wallet">Create Single Collectible</h1>
          <p className="wallet_para">
            Choose “Single” if you want your collectible to be one of a kind or{" "}
            “Multiple” <br /> if you want to sell one collectible multiple times
          </p>
          <div className="seprator"></div>
          <CreateCard />
        </Grid>
      </Grid>
    </div>
  );
}

export default Create;
